import { css, unsafeCSS } from 'lit';
import {sbkCoreBreakpointMd, sbkCoreBreakpointXl} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointXl = unsafeCSS(`${sbkCoreBreakpointXl}`);

export const facet4 = css`
  :host {
  }
    

  .image__facet-4 {
    ::slotted(img), ::slotted(picture) {
      object-fit: cover;
      clip-path: polygon( 5% 72.475%,50.1% 98.5%,95.2% 72.475%,95.2% 46.425%,95.2% 46.425%,94.945% 41.637%,94.194% 36.954%,92.966% 32.412%,91.28% 28.043%,89.156% 23.881%,86.614% 19.961%,83.673% 16.317%,80.352% 12.982%,76.671% 9.99%,72.65% 7.375%,72.65% 7.375%,72.65% 7.375%,68.374% 5.202%,63.942% 3.511%,59.393% 2.304%,54.766% 1.579%,50.1% 1.338%,45.434% 1.579%,40.807% 2.304%,36.258% 3.511%,31.826% 5.202%,27.55% 7.375%,27.55% 7.375%,27.55% 7.375%,23.529% 9.99%,19.848% 12.982%,16.527% 16.317%,13.586% 19.961%,11.044% 23.881%,8.92% 28.043%,7.234% 32.412%,6.006% 36.954%,5.255% 41.637%,5% 46.425%,5% 72.475% );
      aspect-ratio: 1;
      width: 100%;
        height: auto;
      z-index: 2;
    }
  }

  .image-shapes-4 {
    position: absolute;
      top: calc(2% - 2px);
      left: calc(-22% + 1px);
      width: 124%;
      height: auto;
    z-index: 3;
  }

  .image-shapes-4--xl, .image-shapes-4--crop-mobile, .image-shapes-4--crop-mobile-overlay {
    display: none;
  }

  @media screen and (min-width: ${breakpointXl}) {
    .image-shapes-4--xl {
      display: block;
      position: absolute;
        top: 1%;
        left: -19%;
        width: 119%;
      height: auto;
      z-index: 3;
    }
    .image-shapes-4 {
        display: none;
    }
      .image__facet-4--alternative .image-shapes-4--xl {
          top: -3.5%;
          left: -5.4%;
          width: 128%;
      }
  }

    .image__facet-4--crop-mobile {
        ::slotted(img), ::slotted(picture) {
            aspect-ratio:  4 / 3;
            clip-path: polygon( 3.647% 0%,3.647% 0%,2.97% 2.318%,2.359% 4.671%,1.816% 7.056%,1.341% 9.471%,0.936% 11.913%,0.602% 14.381%,0.341% 16.871%,0.152% 19.381%,0.038% 21.909%,0% 24.452%,0% 62.226%,49.983% 100%,100.025% 62.226%,100.025% 24.452%,100.025% 24.452%,99.987% 21.909%,99.873% 19.381%,99.685% 16.871%,99.423% 14.381%,99.089% 11.913%,98.684% 9.471%,98.209% 7.056%,97.666% 4.671%,97.055% 2.318%,96.378% 0%,3.647% 0% );
        }
        .image-shapes-4, .image-shapes-4--xl {
            display: none;
        }
        .image-shapes-4--crop-mobile, .image-shapes-4--crop-mobile-overlay {
            display: block;
        }
        @media screen and (min-width: ${breakpointMd}) {
            ::slotted(img), ::slotted(picture) {
                aspect-ratio: 1;
                clip-path: polygon( 5% 72.475%,50.1% 98.5%,95.2% 72.475%,95.2% 46.425%,95.2% 46.425%,94.945% 41.637%,94.194% 36.954%,92.966% 32.412%,91.28% 28.043%,89.156% 23.881%,86.614% 19.961%,83.673% 16.317%,80.352% 12.982%,76.671% 9.99%,72.65% 7.375%,72.65% 7.375%,72.65% 7.375%,68.374% 5.202%,63.942% 3.511%,59.393% 2.304%,54.766% 1.579%,50.1% 1.338%,45.434% 1.579%,40.807% 2.304%,36.258% 3.511%,31.826% 5.202%,27.55% 7.375%,27.55% 7.375%,27.55% 7.375%,23.529% 9.99%,19.848% 12.982%,16.527% 16.317%,13.586% 19.961%,11.044% 23.881%,8.92% 28.043%,7.234% 32.412%,6.006% 36.954%,5.255% 41.637%,5% 46.425%,5% 72.475% );
            }
            .image-shapes-4 {
                display: block;
            }
            .image-shapes-4--crop-mobile, .image-shapes-4--crop-mobile-overlay {
                display: none;
            }
        }
    }

    .image-shapes-4--crop-mobile {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        z-index: 1;
    }
    .image-shapes-4--crop-mobile-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        z-index: 2;
    }
`;